export default __webpack_public_path__ + "static/media/Benchmarks.eb28af43.svg";